export const sanitizeTags = (tags: string) => {
    return tags.split(',').map(tag => tag.trim());
}
